$( document ).ready(function() {
    $(".navbar-toggler").click(function(){
        $(".collapse").slideToggle();
         });

$(".dropdown-toggle").click(function(){
    $(this).parent().toggleClass("activenav");
});
     
$('.accordion .acc:nth-child(1) .acc-head').addClass('active');
$('.accordion .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.acc-content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.acc-content').slideUp();
    $('.acc-head').removeClass('active');
    $(this).siblings('.acc-content').slideToggle();
    $(this).toggleClass('active');
    }
});  

$('.upslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:1,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              
            }
          }      
      
      
      ]
    
});


  $('.mainimage').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    adaptiveHeight: true,
    asNavFor: '.thumbimage'
  });
  $('.thumbimage').slick({
    slidesToShow:6,
    slidesToScroll: 1,
     arrows: false,
    asNavFor: '.mainimage',
    adaptiveHeight: true,
    dots: false,
    //centerMode: true,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:4,
              slidesToScroll:1,
              infinite: true,
              dots: false,
              
            }
          }

      ]
 
}); 


$('.seeonslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:3,
              slidesToScroll:1,
              infinite: true,
              
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              
            }
          }      
      
      
      ]
    
});

$('.testimonialslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:2,
    slidesToScroll:1,
    autoplay: true,
    centerMode:true,
    responsive: [
      {
            breakpoint:1300,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
        {
            breakpoint:1200,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
              
            }
          }      
      
      
      ]
    
});


$('.beniftslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    //centerMode:true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint:992,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
            }
          },
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              centerMode:false,
              
            }
          }      
      
      
      ]
    
});


  $('#sl').on('change', function() {
  var v = $(this).val();  
  var price = $('option:selected',this).attr("data-price");
    $(".subscribebox .variantnewprice").html(price);
  $("#sellingplan").attr('value',v);
});


  $(".subscribebox").click(function(){
    $(this).addClass("active");
    $(".onetimebox").removeClass("active");
    var pr = $('#sl option:selected',this).attr("data-price");
    $(".subbtn b").text(pr);
    var v = $('#sl option:selected').val(); 
    $("#sellingplan").attr('value',v);
  });
  $(".onetimebox").click(function(){
    $(this).addClass("active");
    var pr = $(this).find("input").attr("data-pr");
    $(".subbtn b").text(pr);
    $(".subscribebox").removeClass("active");
    $("#sellingplan").attr('value',"");
  });


});	

// Annually vs Monthly PDP
function initializePaymentOptions() {
  const payOptionsContainer =
    document.querySelector(".pay-options") || document;
  const payOptions = payOptionsContainer.querySelectorAll(".pay-option");
  const radioInputs = payOptionsContainer.querySelectorAll(".pay-option-radio");
  const monthlyPriceSection = document.querySelector(".monthly-price");
  const annuallyPriceSection = document.querySelector(".annually-price");

  function updateActiveStates(selectedOption) {
    payOptions.forEach((option) => {
      option.classList.remove("active");
    });

    selectedOption.classList.add("active");
    // Toggle price sections based on selection
    if (selectedOption.classList.contains("monthly")) {
      monthlyPriceSection.style.display = "flex";
      annuallyPriceSection.style.display = "none";
    } else if (selectedOption.classList.contains("annually")) {
      monthlyPriceSection.style.display = "none";
      annuallyPriceSection.style.display = "flex";
    }
  }

  payOptions.forEach((payOption) => {
    payOption.addEventListener("click", function (e) {
      const radioInput = this.querySelector(".pay-option-radio");

      radioInput.checked = true;

      updateActiveStates(this);

      radioInput.dispatchEvent(new Event("change"));
    });
  });

  radioInputs.forEach((radio) => {
    radio.addEventListener("change", function () {
      if (this.checked) {
        const parentPayOption = this.closest(".pay-option");
        updateActiveStates(parentPayOption);
      }
    });
  });

  const checkedRadio = document.querySelector(".pay-option-radio:checked");
  if (checkedRadio) {
    const parentPayOption = checkedRadio.closest(".pay-option");
    updateActiveStates(parentPayOption);
  }
}

document.addEventListener("DOMContentLoaded", initializePaymentOptions);

// CLEAR CART FUNCTION
async function clearCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart cleared:", data));
}



// CW UPSELL LOADER
function showLoader() {
  document.querySelector(".loader-container").classList.add("show");
  $("html").css({ overflow: "hidden" });
}

function hideLoader() {
  document.querySelector(".loader-container").classList.remove("show");
  $("html").css({ "overflow-y": "auto" });
}

$(document).ready(function () {
  $(".productmain .primarybtn").click(async function (event) {
    showLoader();
    if ($(this).hasClass("upsell-logic")) {
      event.preventDefault();
      await clearCart();

      // await updateCart(
      //   $(this).attr("data-variant-id"),
      //   1,
      //   $(this).attr("data-selling-plan")
      // )
      // localStorage.setItem(
      //   "product",
      //   JSON.stringify({
      //     name: $(this).attr("data-product-name"),
      //     variantId: $(this).attr("data-variant-id"),
      //     sellingPlanId: $(this).attr("data-selling-plan"),
      //     price: $(this).attr("data-price"),
      //     quantity: 1,
      //     prev: window.location.href,
      //   })
      // )
      // localStorage.setItem(
      //   "one-time-fee",
      //   JSON.stringify({
      //     name: "COR One Setup Fee",
      //     variantId: "45967451521187",
      //     price: "$59.00",
      //     quantity: 1,
      //   })
      // )
      var items = [
        {
          id: $(this).attr("data-variant-id"),
          quantity: 1,
        },
      ];

      await addItemsToCart(items);
      //hideLoader();
      localStorage.getItem("prevPath", window.location.href)
      window.location.assign(event.target.href);
      // window.location.href = "/cart"
    }
  });

  if ($(document).find(".cw-bundle-content").length > 0) {
    // var product = JSON.parse(localStorage.getItem("product"))
    // var fee = JSON.parse(localStorage.getItem("one-time-fee"))
    // if (product) {
    //   // <span class="cw-item-quantity">x ${product.quantity}</span>
    //   $(".cw-summary-box .cw-item-list").prepend(
    //     `<li class="item main-product ${product.variantId}">
    //       <span class="label">${product.name}</span>
    //       <span class="price">${product.price}</span>
    //     </li>`
    //   )
    //   calculateTotal()
    // }
    // if (fee) {
    //   // <span class="cw-item-quantity">x ${product.quantity}</span>
    //   $(".cw-summary-box .cw-item-list").prepend(
    //     `<li class="item main-product ${fee.variantId}">
    //       <span class="label">${fee.name}</span>
    //       <span class="price">${fee.price}</span>
    //     </li>`
    //   )
    //   calculateTotal()
    // }
  }
  // $(".cw-upsell-back").on("click", function (event) {
  //   event.preventDefault();
  //   console.log(localStorage.getItem("prevPath"))
  //   window.location.href =
  //     JSON.parse(localStorage.getItem("prevPath")) ?? "/";
  //   localStorage.removeItem("prevPath")
  // });
  $(".cw-bundle-content .primarybtn ").on("click", async function (event) {
    event.preventDefault();
    if ($(this).attr("disabled")) return;
    $(this).attr("disabled", true);
    $(this).text("Processing...");
    // var addons = $(".cw-item-list .item").not(".cart-product, .total")
    // var items = []
    // addons.each(function () {
    //   var addon = $(this)
    //   items.push({
    //     id: addon.attr("data-variant-id"),
    //     product_id: addon.attr("data-product-id"),
    //     quantity: 1,
    //     selling_plan: addon.attr("data-selling-plan"),
    //   })
    // })
    // if (fee) {
    //   items.push({
    //     id: fee.variantId,
    //     quantity: 1,
    //   })
    // }
    // await clearCart()
    // await addItemsToCart(items)
    // localStorage.removeItem("product")
    // localStorage.removeItem("one-time-fee")
    // if (product) {
    //   window.location.href = getSingleProductCheckoutUrlPath(
    //     product.variantId,
    //     product.sellingPlanId
    //   )
    // } else {
    // }
    window.location.href = "/checkout";

    // window.location.href = "/cart"
  });
});

function calculateTotal() {
  var total = 0;
  var currencySymbol = "";
  var firstPriceText = $(".cw-summary-box li .price").first().text();
  if (firstPriceText.length > 0) {
    currencySymbol = firstPriceText.charAt(0);
  }
  $(".cw-summary-box li").each(function () {
    var priceText = $(this).find(".price").text();
    if (priceText.length > 0) {
      var cleanPriceText = priceText.substring(1);
      total += parseFloat(cleanPriceText);
    }
  });
  total = total.toFixed(2);

  $(".cw-summary-box .total .totalamount").text(currencySymbol + total);
}

async function clearCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart cleared:", data));
}

async function updateCart(items) {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items,
    }),
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart updated:", data));
}

// A more robust way to ensure items are added after clear
async function addItemsToCart(items) {
  // Loop through each item and add it individually
  for (const item of items) {
    await fetch("/cart/add.js", {
      // Use /cart/add.js
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: item.id,
        quantity: item.quantity,
        selling_plan: item.selling_plan, // if not empty
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            throw new Error(
              `Failed to add item ${item.id}: ${JSON.stringify(errorData)}`
            );
          });
        }
        return response.json();
      })
      .then((data) => console.log(`Item ${item.id} added:`, data))
      .catch((error) => console.error(error));
  }
  // After all items are added, you can fetch the cart to get the final state
  return fetch("/cart.js").then((response) => response.json());
}

async function removeFromCart(variantId) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId, // The variant ID of the item to remove
      quantity: 0,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      // Update cart display
    });
}
